import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { MatCardModule } from '@angular/material/card';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import {
  IonicSelectableComponent,
  IonicSelectableItemTemplateDirective,
} from 'ionic-selectable';
import { DirectivesModule } from '../directives/directives.module';
import { AdvertisingComponent } from './advertising/advertising.component';
import { BillDetailComponent } from './bill-detail/bill-detail.component';
import { ButtonsModalComponent } from './buttons-modal/buttons-modal.component';
import { ConfirmTermsAndConditionComponent } from './confirm-terms-and-condition/confirm-terms-and-condition.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { ContestBannersComponent } from './contest-banners/contest-banners.component';
import { CustomErrorAlertComponent } from './custom-alert/custom-alert.component';
import { FormComponent } from './form/form.component';
import { GetBillsComponent } from './get-bills/get-bills.component';
import { InputPhoneComponent } from './input-phone/input-phone.component';
import { LoadingComponent } from './loading/loading.component';
import { LoginComponent } from './login/login.component';
import { MessageDialogComponent } from './message-dialog/message-dialog.component';
import { MultipleOptionsModalComponent } from './multiple-options-modal/multiple-options-modal.component';
import { OtpVerificationModalComponent } from './otp-verification-modal/otp-verification-modal.component';
import { ProgressiveProfileComponent } from './progressive-profile/progressive-profile.component';
import { SelectContestComponent } from './select-contest/select-contest.component';
import { SignupComponent } from './signup/signup.component';
import { UpdateDataComponent } from './update-data/update-data.component';
import { UploadBillComponent } from './upload-bill/upload-bill.component';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    IonicSelectableComponent,
    IonicSelectableItemTemplateDirective,
    DirectivesModule,
    MatCardModule,
    MatDatepickerModule,
    InputPhoneComponent,
    MultipleOptionsModalComponent
  ],
  declarations: [
    SelectContestComponent,
    LoginComponent,
    FormComponent,
    GetBillsComponent,
    SignupComponent,
    UploadBillComponent,
    BillDetailComponent,
    AdvertisingComponent,
    ProgressiveProfileComponent,
    UpdateDataComponent,
    LoadingComponent,
    CustomErrorAlertComponent,
    ConfirmationModalComponent,
    ButtonsModalComponent,
    ConfirmTermsAndConditionComponent,
    MessageDialogComponent,
    OtpVerificationModalComponent,
    ContestBannersComponent
  ],
  exports: [
    SelectContestComponent,
    LoginComponent,
    FormComponent,
    GetBillsComponent,
    SignupComponent,
    UploadBillComponent,
    BillDetailComponent,
    AdvertisingComponent,
    ProgressiveProfileComponent,
    UpdateDataComponent,
    LoadingComponent,
    CustomErrorAlertComponent,
    ConfirmationModalComponent,
    ButtonsModalComponent,
    InputPhoneComponent,
    MultipleOptionsModalComponent,
    OtpVerificationModalComponent,
    ContestBannersComponent
  ],
  providers: [
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'es-mx',
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: MAT_MOMENT_DATE_FORMATS,
    },
    CurrencyPipe,
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class ComponentsModule {}
